import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FilteringService {

  constructor() { }

  /**
   * Return the string in Title Case (First letter of each word in upper case)
   *
   * @param str string to transform to Title Case
   */
  toTitleCase(str) {
    return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

}
